//default from angular libraries
import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

//import services
import { SuperAdminService } from '../../../services/superadmin.service';
import { AppFrontRoutes } from '../../../constants/app-front-routes';
import { AppSettings } from 'src/app/constants/app-settings';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
@Component({
  selector: 'app-super_admin_mail_config',
  templateUrl: './super_admin_mail_config.component.html',
  styleUrls: ['./super_admin_mail_config.component.css'],
//   host: {'id': 'content'},
  providers: [SuperAdminService]
})

export class SuperAdminMailConfigComponent implements OnInit {
    id:string = ""
    userdata:any;
    readonly AppFrontRoutes = AppFrontRoutes;
    readonly AppSettings = AppSettings;    
    mailConfigForm: FormGroup;
    mailConfigFormSubmitted:boolean = false
  	constructor(
          private route: ActivatedRoute,
          private router: Router,
          private superadminService : SuperAdminService,
          private formBuilder: FormBuilder,
          private generalService:GeneralService
    ) { }

  	ngOnInit() {
        this.mailConfigForm = this.formBuilder.group({
            deadline: ['', [Validators.required]],
            servicing: ['', [Validators.required]],
            hr_courses: ['', [Validators.required]],
            hr_notification: ['', [Validators.required]],
            hr_visit: ['', [Validators.required]],
            measurement_tools: ['', [Validators.required]],
            problem_solving: ['', [Validators.required]],
            document_management: ['', [Validators.required]],
            customers: ['', [Validators.required]],
            consultancy: ['', [Validators.required]],
            academy: ['', [Validators.required]],
            project: ['', [Validators.required]],
            action: 'save',
          });         
        this.getMails()          
    }

    getValue(type,emails){
        let obj = emails.filter(function(ele){
            return ele.module_name == type
        })
        return obj[0].email
    }

    setFormValues(emails){
        this.mailConfigForm.patchValue({
            deadline: this.getValue("deadline",emails),
            servicing: this.getValue("servicing",emails),
            hr_courses: this.getValue("hr_courses",emails),
            hr_notification: this.getValue("hr_notification",emails),
            hr_visit: this.getValue("hr_visit",emails),
            measurement_tools: this.getValue("measurement_tools",emails),
            problem_solving: this.getValue("problem_solving",emails),
            document_management: this.getValue("document_management",emails),
            customers: this.getValue("customers",emails),
            consultancy: this.getValue("consultancy",emails),
            academy: this.getValue("academy",emails),
            project: this.getValue("project",emails),
        })
    }
    
    getMails(){
        this.superadminService.getMails().subscribe(
            (res) => {
                console.log(res)
                if(res.status){                    
                    this.userdata = res.data.user_data
                    this.setFormValues(res.data.emails)
                }
            }
        );
    }

    formErrorClass(value, submitted): string {
        return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
    }    

    onSubmit(){
        console.log(this.mailConfigForm)
        this.mailConfigFormSubmitted = true

        if (this.mailConfigForm.invalid)
        return;
  
      this.superadminService.updateMailConfig(this.mailConfigForm.value).subscribe(
        res => {
  
          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
          }
          else {
            this.generalService.notify_msg('error', res.data);
          }
  
        }
      );        
    }

}
